import { makeAutoObservable, observable, when } from 'mobx';
import { Circle } from '@gamiphy/bl/connections';
import { CircleApi } from '@gamiphy/gamix-modules/circle';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';

class CirclesStore {
    @observable initialized = false;

    @observable circles: Circle[] = [];

    constructor() {
      makeAutoObservable(this);

      when(() => AppStore.initialized && UserStore.isLoggedIn, () => {
        void Promise.all([
          AppStore.app ? CircleApi.getConnections() : [],
        ])
          .then(([connections]) => {
            this.circles = connections;
            this.initialized = true;
          });
      });
    }
}

export default new CirclesStore();
